import React from 'react'
import ReactDOM from 'react-dom';

export default class DropdownSchoolGroupMultiple extends React.Component
{		
	
	// Entry properties
	//
	// mode : 'list' - Just act like a dropdown with each role itemised
	//        'filter' - act as a drop down filter list, including an 'ALL' option
	//		  'multiple' - act as a multipl e select list 
	
	constructor(props)
	{
		super(props);
		
		this.keyCount = 1 ;

    	// Create a state item here for all items on the form  (Using their id )
		this.state = { open: false, items: null, dirty: false, currentItems: this.props.defaultItems };

		this.handleChange = this.handleChange.bind(this) ;
		
	}

	UNSAFE_componentWillReceiveProps(nextProps)
	{
		var l1 = nextProps.defaultItems.length ;
		var l2 = this.state.currentItems.length ;

		if ( l2 != l1 )
		{
			this.setState ( {currentItems: nextProps.defaultItems} );
		}
	}

	UNSAFE_componentWillMount()
	{	
		if ( this.props.groups == null ) 
		{
			// Fetch the list of types to populste the dropdown
			this.getGroupsForSchool ( this.props.school_id) ;			
		}
		else
		{
			this.setState ({items:this.props.groups});
		}
	}
	
	componentDidMount()
	{
	    var self = this;
	    var select = $(ReactDOM.findDOMNode(this)).find('select');
	    
	    $(select).selectpicker({ size: 6});

	    var button = $(ReactDOM.findDOMNode(this)).find('button');
	    var dropdown = $(ReactDOM.findDOMNode(this)).find('.dropdown-menu.open');
	    var items = $(ReactDOM.findDOMNode(this)).find('ul.dropdown-menu li a');

	    $('html').click(function () {
	      self.setState({ open: false });
	    });

	    button.click(function (e) {
	      e.stopPropagation();
	      self.setState({ open: !self.state.open });
	    });

	    items.click(function () {
	      if (self.props.multiple) return;
	      self.setState({ open: !self.state.open });
	    });
	}
	
	componentDidUpdate()
	{
	    $(ReactDOM.findDOMNode(this)).find('select').selectpicker('refresh');
	    
	    var select = $(ReactDOM.findDOMNode(this)).find('div.bootstrap-select');

	    select.toggleClass('open', this.state.open);
	}
	
	componentWillUnmount()
	{
	    var self = this;
	    var select = $(ReactDOM.findDOMNode(this)).find('select');

	    var button = $(ReactDOM.findDOMNode(this)).find('button');
	    var dropdown = $(ReactDOM.findDOMNode(this)).find('.dropdown-menu.open');
	    var items = $(ReactDOM.findDOMNode(this)).find('ul.dropdown-menu li a');

	    $('html').off('click');
	    button.off('click');
	    items.off('click');
	}
	
	getGroupsForSchool( school_id )
	{
		// Globals are defined in the globals.js class
		var root = Globals.APIFolder ;
		
    	$.ajax({
    		  type: 'GET',
    		  url: root + '/schools/' + school_id + '/schoolgroups',
    		  data: { },
    		  beforeSend:function(){
    		    // this is where we append a loading image
    		  },
    		  success:(data)=>{

    			// We've got something back, so set the data field in the REACT component STATE
    			// THis will be used in the RENDER function
    			  
  				this.setState({ items: data.data });
  				
    		  },
    		  error:(jqXHR, textStatus, error)=>{

					bootbox.alert({ 
					  size: "large",
					  title: "The operation failed",
					  message: error.stack + '\n' + jqXHR.responseText + '<br><br>' + getErrorObject().stack,  
					  callback: function()
					  { 
					  }
					})	    		  	
  		  		}

    		});
	}
	
	/**
	* Returns true if the input value complies with the validation rules supplied
	* 
	* @param {string} param - The value of the string to be tested.
	* @return {bool} true if the test passes.
	*/
	isValueValid( param )
	{
		if ( this.props.validation != null )
		{
			if ( this.props.validation.required == true )
			{
				if ( param == null || param == 0)
				{
					return false ;
				}
			}
			else
			{
				if ( param == null || param == 0)
				{
					// If not required, and empty, it's OK
					return true ;
				}
			}			
		}

		return true ;
	}

	/**
	* Externally callable function to test if the input field is valid
	* 
	* @return {bool} True if the field is valid.
	*/
	isValid()
	{		
		return this.isValueValid ( this.getValue() ) ;
	}
	
    getValue()
    {
    	return this.state.currentItems ;
    }
    
	/**
	* Externally callable function to test if the input field is valid
	* 
	* @return {bool} True if the field is valid.
	*/
	isDirty()
	{		
		return this.state.dirty ;
	}

	setDirty ( value )
	{
		this.setState ({dirty: value}) ;
	}
	
	handleChange(e, checked) 
	{
		if ( this.props.readOnly != 'readonly' )
		{
			var targetName = e.target.name ;
			var val = e.target.value ;
			var index = e.target.selectedIndex;

			// Need to calculate the offset to read the actual Type Id from the correct place in the table
			// If it is a 'filter' then there is an extra entry in the listbox called 'ALL' which we need to account for

			var offset = 0 ; 

			var o = e.target.selectedOptions ;

			var i = 0 ;
			var len = o.length ;

			var selectedItems = [] ;

			for (i=0; i<len; ++i) 
            {
				selectedItems.push ( o[i].value ) ;
            }
			
			this.setState ( { currentItems: selectedItems }) ;

			// Tell the owning function about the change
			if ( this.props.callback != null )
			{
				this.props.callback ( itemid, itemtext ) ;					
			}
		}
		else
		{
			e.stopPropagation() ;
		}
	}
	  
     
    optionList ()
    {
        var lineList=[];
        
        // This element renders from the list of user types returned by the getdata() ajax function above
    	var itemArray = this.state.items ;

    	if ( itemArray != null )
        {
        	var i = 0 ;
            var len = itemArray.length;
            var row = null ;
            var typeId = null ;
            var typeText = null ;
            
            // If it's a filter list, add the 'ALL' option

            if ( this.props.readOnly == 'readonly')
			{
				var state = 'disabled' ; 
			}
			else
			{
				var state = null ;
			}
            
            if ( this.props.mode == 'filter' )
        	{
        		lineList.push(React.createElement ( 'option', {key: this.keyCount++, name: 0, value: 0} , 'All Groups'));        	
        		lineList.push(React.createElement ( 'option', {key: this.keyCount++, name: 'ungrouped', value: 'ungrouped'} , 'Ungrouped'));        	
        	}
        	else if ( this.props.mode == 'list')
        	{
        		lineList.push(React.createElement ( 'option', {key: this.keyCount++, disabled: state, name: 0, value: 0} , 'No Group'));        	        		
        	}
    		
            for (i=0; i<len; ++i) 
            {
            	if (i in itemArray) 
            	{
            		row = itemArray[i];
            		
            		typeId = row.school_group_id ;
            		typeText = row.school_group_name;
            		
            		lineList.push(React.createElement ( 'option', {key: this.keyCount++,  disabled: state, name: typeId, value: typeId} , typeText));        			
            	}
            }
        }
        
        return lineList ;
    }
    
    dropdown_select ( id )
    {
    	if ( this.props.style != null )
		{
			var style = this.props.style ;
		}
		else
		{
			var style = {} ;
		}	

	    if ( this.props.readOnly == 'readonly' || this.props.readonly == true)
		{
	    	style.borderColor = '#ecf3f9' ;
	    	style.paddingLeft = '0px';
	    	style.color = '#428bcd';
		}

		if ( this.props.readOnly == 'readonly')
		{
			var onChangeHandler = null ;
		}
		else
		{
			var onChangeHandler = this.handleChange ;			
		}

    	return React.createElement ( 'select', {key: 'select1', 
			value: this.state.currentItems, 
    		readOnly: this.props.readOnly,
			className: 'selectpicker form-control', 
			multiple: true,
			id: id , 
    		style: style,
        	onChange: onChangeHandler }, this.optionList() ) ;
    }
    
    
    /**
     * Generates HTML for the error DIV which wil be visible if the field contents are
     * invalid AND the this.props.displayErrors flag is set. This will generally be set 
     * by the parent form if error display is required.
     * 
     * @param {bool} validFlag - True if this field is currnetly invalid.
     * @return {void} 
     */
	errorDiv ( validFlag )
	{
		var errmsg = "Invalid Value";
		
		if ( this.props.errorText != null )
		{
			if ( this.props.errorText.length != 0)
			{
				errmsg = this.props.errorText ;
			}
		}

		var className = 'input-error-invisible' ;
		
		if ( this.props.displayErrors == true && this.isValid() != true )
		{
			className = 'input-error-visible' ;
		}
		
		return React.createElement ('div', {  htmlFor: this.props.id, key: this.keyCount++, className: className} , errmsg ) ;		
	}
	
    optionDropdown(id)
    {
    	var lineList=[];
    	
        lineList.push (React.createElement('label', {  key: 'label1', htmlFor: this.props.id, className: 'col-form-label'}, this.props.label ));
    	lineList.push( this.dropdown_select(id));

    	if ( this.props.displayErrors == true )
    	{
            lineList.push ( this.errorDiv(true) ) ;    	
    	}
    	
    	return lineList ;
    }
  
    render() 
    {
        return React.createElement ( 'div', {key: 'inputgroup1', className: 'input-group'}, this.optionDropdown('list1')) ;				
    }
};


